const STORAGE_KEY = "peak_education_fbclid";

export interface StoredClick {
  fbclid: string;
  timestamp: number;
}

/** Meta click cookie: fb.1.{timestamp}.{fbclid} */
export function fbcFromClick(fbclid: string, timestamp: number): string {
  return `fb.1.${timestamp}.${fbclid}`;
}

export function rememberFbclid(search: string, now = Date.now()): void {
  if (typeof localStorage === "undefined") return;
  const fbclid = new URLSearchParams(search).get("fbclid");
  if (!fbclid) return;
  const stored: StoredClick = { fbclid, timestamp: now };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
}

export function readStoredClick(): StoredClick | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredClick>;
    if (typeof parsed.fbclid !== "string" || !parsed.fbclid) return null;
    if (typeof parsed.timestamp !== "number") return null;
    return { fbclid: parsed.fbclid, timestamp: parsed.timestamp };
  } catch {
    return null;
  }
}

function cookieValue(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

export function readFbpCookie(): string | null {
  return cookieValue("_fbp");
}

export function readFbcCookie(): string | null {
  return cookieValue("_fbc");
}

/** Prefer the cookie Meta set. Otherwise rebuild _fbc from the stored click id. */
export function currentFbc(): string | null {
  const cookie = readFbcCookie();
  if (cookie) return cookie;
  const stored = readStoredClick();
  if (!stored) return null;
  return fbcFromClick(stored.fbclid, stored.timestamp);
}
